const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/bg_text_logo.png"
    style={{height: 36}}
    {...props}
  />
);

export default Logo;
